import { NgModule } from '@angular/core';
import { Apollo } from 'apollo-angular';
import { InMemoryCache } from '@apollo/client/core';
import { ApolloLink, from } from 'apollo-link';
import { ErrorResponse, onError } from '@apollo/client/link/error';
import { BatchHttpLink } from 'apollo-link-batch-http';
import { filter, switchMap } from 'rxjs/operators';

import { environment } from '../environments/environment';
import { AuthService, StorageService } from '@tripointe/tripointe-cms/services';

const uri = environment.graphQlUrl;
@NgModule()
export class GraphQLModule {
  constructor(
    private apollo: Apollo,
    private storageService: StorageService,
    private authService: AuthService
  ) {
    this.init();
  }

  init(): void {
    this.apollo.create({
      link: this.generateNewLink() as any,
      cache: new InMemoryCache(),
      defaultOptions: {
        query: {
          fetchPolicy: 'network-only'
        }
      }
    });
  }

  generateNewLink(): any {
    const authMiddleware = this.getAuthContext();
    const httpLinkBatch = new BatchHttpLink({ uri });
    const errorLink = onError(res => this.getErrorLink(res));

    return errorLink.concat(from([authMiddleware, httpLinkBatch]) as any);
  }

  getErrorLink(res: ErrorResponse): any {
    const responseStatus = res.graphQLErrors?.[0]?.extensions?.statusCode;

    if (responseStatus === 401) {
      return this.authService.refreshTokens().pipe(
        filter(Boolean),
        switchMap(authRes => res.forward(res.operation))
      );
    }

    if (responseStatus === 403) {
      this.authService.logout();
    }
  }

  getAuthContext(): ApolloLink {
    return new ApolloLink((operation, forward) => {
      const token = this.storageService.get('accessToken');
      operation.setContext(() => ({
        headers: {
          Authorization: token ? `Bearer ${token}` : ''
        }
      }));

      return forward(operation);
    });
  }
}
